module.exports = __webpack_public_path__ + "img/nav-offers.33066c44.svg";